import classNames from "classnames";

const Container: React.FC<any> = (props: any) => {
  const { pathname } = useLocation();
  const rahu_kaal_page = pathname.startsWith("/rahu-kaal");
  return (
    <div
      className={classNames([
        "flex flex-col justify-start color-[var(--app-text-04)]",
        rahu_kaal_page ? "flex-[1]" : "",
      ])}
      {...props}
    ></div>
  );
};
export default Container;
